<template>
  <div>
    <p>
      Explore REKOM’s Media Library – a comprehensive resource offering images,
      videos, and digital assets for download, empowering you to enhance your
      projects with captivating, relevant and ready to use visuals. Download and
      use them in your Canva designs, Powerpoints, newsletters or anywhere else
      where you need visuals to improve your work.
    </p>
    <vs-row>
      <vs-button
        icon="icon-external-link"
        icon-pack="feather"
        class="mt-5 library-icon"
        href="https://rekomgroup.bynder.com/web/46bc668f11e1aa0d/workspace-collection-/"
        target="_blank"
      >
        REKOM Media Library</vs-button
      >
    </vs-row>

    <vs-row>
      <vs-button
        icon="icon-external-link"
        icon-pack="feather"
        class="mt-5 library-icon-dark"
        type="border"
        href="https://rekomgroup.bynder.com/"
        target="_blank"
      >
        Upload to Media Library</vs-button
      >
    </vs-row>

    <!-- <div id="importedAssets"></div>
    <div id="bynderContainer"></div>
    <script
      type="application/javascript"
      src="https://ucv.bynder.com/5.0.5/modules/compactview/bynder-compactview-3-latest.js"
    ></script>
    <script type="application/javascript">
    setTimeout(() => {

      BynderCompactView.open({
        language: "en_US",
        theme: {
          colorButtonPrimary: "#3380FF",
        },
        portal: {
          url: "rekomgroup.bynder.com",
        },
        mode: "SingleSelectFile",
        onSuccess: function (assets, additionalInfo) {
          var importedAssetsContainer = document.getElementById("importedAssets");
          importedAssetsContainer.innerHTML = "";

          var asset = assets[0];

          console.log(asset, additionalInfo);

          switch (asset.type) {
            case "IMAGE":
              importedAssetsContainer.innerHTML += "<img src=" + additionalInfo.selectedFile.url + " />";
              return;
            case "AUDIO":
            case "DOCUMENT":
              importedAssetsContainer.innerHTML += "<img src=" + asset.files.webImage.url + " />";
              return;
            case "VIDEO":
              importedAssetsContainer.innerHTML +=
                '<video width="640" height="480" controls>' +
                '<source src="' +
                asset.previewUrls[0] +
                '" type="video/webm">' +
                "</video>";
              return;
            default:
              return;
          }
        },
      });
    }, 500);
    </script> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
.library-icon {
  font-size: 1.2rem;
  padding: 1rem 2rem !important;

  .vs-icon {
    color: #e0be7c !important;
    font-size: 1.2rem;
  }
}
.library-icon-dark {
  border-width: 2px;
  font-size: 1.2rem;
  padding: 1rem 2rem !important;

  .vs-icon {
    color: #17312d !important;
    font-size: 1.2rem;
  }
}
</style>